import { render } from "./search-icon.svg?vue&type=template&id=ee3ed6fa"
import script from "./search-icon.svg?vue&type=script&lang=js"
export * from "./search-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src539/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__